import * as React from 'react';
import Pickup from './Pickup';

const EditPickup = (props: any) => {
  return <Pickup isEdit={true} {...props} />;
};

export default EditPickup;